import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_360.svg';
import Icon, { IconProps } from './icon';

const Icon360 = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default Icon360;
